module.exports = __webpack_public_path__ + "img/触达城市.d795df95.svg";